import React, { useState } from "react";
import { X } from "lucide-react";

interface RefundReasonModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  loading?: boolean;
}

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalStyle: React.CSSProperties = {
  backgroundColor: "#ffffff",
  width: "100%",
  maxWidth: "420px",
  borderRadius: "16px",
  padding: "24px",
  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
  position: "relative",
};

const buttonBase: React.CSSProperties = {
  padding: "10px 16px",
  borderRadius: "10px",
  cursor: "pointer",
  fontSize: "14px",
  border: "1px solid #ddd",
};

const RefundReasonModal: React.FC<RefundReasonModalProps> = ({
  open,
  onClose,
  onSubmit,
  loading = false,
}) => {
  const [reason, setReason] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    if (!reason.trim()) return;
    onSubmit(reason.trim());
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "#666",
          }}
        >
          <X size={20} />
        </button>

        <h2 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "16px" }}>
          Refund Reason
        </h2>

        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter refund reason..."
          style={{
            width: "100%",
            height: "110px",
            padding: "12px",
            borderRadius: "12px",
            border: "1px solid #ddd",
            outline: "none",
            resize: "none",
            marginBottom: "20px",
          }}
        />

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
          <button onClick={onClose} style={buttonBase}>
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={!reason.trim() || loading}
            style={{
              ...buttonBase,
              backgroundColor: "#000",
              color: "#fff",
              border: "none",
              opacity: !reason.trim() || loading ? 0.6 : 1,
            }}
          >
            {loading ? "Processing..." : "Submit Refund"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundReasonModal;